import { useSyncExternalStore } from 'react';

/* dashboard-rediseno (seccion "Layout por tamano de pantalla" y 4.1 del encargo): LA FUENTE UNICA DE LAS MEDIDAS
   DEL CHASIS. La barra de arriba mide 64 (56 abajo de 768) mas la zona segura de arriba; el menu lateral mide 248
   desde 1024, 80 (solo iconos) de 768 a 1023 y no existe abajo de 768 (ahi manda la barra de abajo de hoy, ver
   `bottomNavMetrics.js`). Hasta esta tanda esos numeros estaban escritos a mano en App.js, Sidebar.js y en el alto
   del contenido; ahora viven aqui y nada mas aqui (lo vigila `medidasDelChasis.dr.test.js`).

   LAS CLASES SON CADENAS COMPLETAS Y LITERALES, por la misma razon que en `bottomNavMetrics.js`: Tailwind solo
   genera lo que ve escrito entero. Los numeros sueltos existen para que las pruebas comprueben que las cadenas y los
   numeros no se separaron. Los cortes son los de Tailwind: sm 640, md 768, lg 1024. */

export const BARRA_ALTO_PX = 64;
export const BARRA_ALTO_TELEFONO_PX = 56;
export const MENU_COMPLETO_PX = 248;
export const MENU_ICONOS_PX = 80;
export const AIRE_DE_LOS_AVISOS_PX = 16;

/** El alto de la barra de arriba, con la zona segura del iPhone. */
export const BARRA_ALTO_CLASS = 'h-[calc(56px+env(safe-area-inset-top))] md:h-[calc(64px+env(safe-area-inset-top))]';

/** El contenido (el `<main>`) empieza debajo de la barra. */
export const CONTENIDO_DEBAJO_DE_LA_BARRA_CLASS = 'mt-[calc(56px+env(safe-area-inset-top))] md:mt-[calc(64px+env(safe-area-inset-top))]';

/** El contenido deja libre el ancho del menu lateral: 80 de 768 a 1023, 248 desde 1024. */
export const CONTENIDO_JUNTO_AL_MENU_CLASS = 'md:ml-20 lg:ml-[248px]';

/** El relleno del contenido por la tabla del documento: 16 y 16 abajo de 640; 24 y 24 de 640 a 767; 28 arriba y
 *  24 a los lados de 768 a 1023; 32 arriba y 40 a los lados desde 1024. El de abajo lo siguen poniendo los
 *  colchones de la barra de abajo (`bottomNavMetrics.js`). */
export const RELLENO_DEL_CONTENIDO_CLASS = 'px-4 pt-4 sm:px-6 sm:pt-6 md:pt-7 lg:px-10 lg:pt-8';

/** Una barra pegajosa a lo ancho DENTRO del contenido (la del avance del grupo): sus margenes negativos son
 *  exactamente el relleno de arriba, para pegarse al borde sin hueco. Si cambia el relleno, cambia esto. */
export const PEGAJOSA_A_LO_ANCHO_CLASS = '-top-4 sm:-top-6 md:-top-7 lg:-top-8 -mx-4 sm:-mx-6 lg:-mx-10 px-4 sm:px-6 lg:px-10';

/** El ancho del menu lateral desde 768 (en el telefono es el cajon, que abraza su contenido). */
export const MENU_ANCHO_CLASS = 'md:w-20 lg:w-[248px]';

/** El menu lateral empieza debajo de la barra y llega al fondo. */
export const MENU_DEBAJO_DE_LA_BARRA_CLASS = 'md:top-[calc(64px+env(safe-area-inset-top))] md:h-[calc(100vh-64px-env(safe-area-inset-top))]';

/** tutor-1 (D, firma 8): el menu de tablet ABIERTO mide lo que el menu completo (248), encima del contenido. */
export const MENU_ABIERTO_EN_TABLET_CLASS = 'md:w-[248px]';

/** tutor-1 (D, firma 8): el velo del menu de tablet abierto empieza debajo de la barra de arriba (la deja libre). */
export const VELO_DEL_MENU_DE_TABLET_CLASS = 'top-[calc(64px+env(safe-area-inset-top))]';

/** Un panel flotante de la barra (el de creditos) sale 8 px debajo de ella. */
export const PANEL_DE_LA_BARRA_TOP_CLASS = 'top-[calc(56px+env(safe-area-inset-top)+8px)] md:top-[calc(64px+env(safe-area-inset-top)+8px)]';

/** dashboard-rediseno, vuelta 2 (D3): el alto maximo de ese panel es lo que queda de la ventana debajo de la barra
 *  menos sus 8 de arriba y 16 de aire abajo (24), menos la zona segura de abajo. Con el telefono acostado (390 o 430
 *  de alto) el panel no cabe entero: se desplaza por dentro y su boton queda fijo abajo. `dvh` donde se sabe y `vh`
 *  de respaldo (el iOS 15.0 no resuelve un `dvh` sin respaldo). */
export const PANEL_DE_LA_BARRA_ALTO_MAX_CLASS = 'max-h-[calc(100vh-56px-env(safe-area-inset-top)-24px-env(safe-area-inset-bottom,0px))] supports-[height:100dvh]:max-h-[calc(100dvh-56px-env(safe-area-inset-top)-24px-env(safe-area-inset-bottom,0px))] md:max-h-[calc(100vh-64px-env(safe-area-inset-top)-24px-env(safe-area-inset-bottom,0px))] md:supports-[height:100dvh]:max-h-[calc(100dvh-64px-env(safe-area-inset-top)-24px-env(safe-area-inset-bottom,0px))]';

/** El alto del area de contenido del chasis. Antes vivia en `bottomNavMetrics.js` (que lo re-exporta); se mudo
 *  aqui porque lleva el alto de la barra. La pildora de abajo es de vidrio y el contenido pasa por debajo a
 *  proposito, asi que solo se descuenta la barra de arriba (y su zona segura), con `dvh` donde el navegador lo sabe
 *  y `vh` de respaldo (el iOS 15.0 no resuelve un `dvh` sin respaldo).
 *  tutor-1 (D, #665): LAPIDA. Hasta esta tanda la web descontaba ademas la barra plana de abajo (57 = 56 mas su
 *  borde) y la app no; desde la barra unica las dos casas coinciden y la constante queda sin bifurcar. */
export const CONTENT_HEIGHT_CLASS = 'h-[calc(100vh-56px-env(safe-area-inset-top))] supports-[height:100dvh]:h-[calc(100dvh-56px-env(safe-area-inset-top))] md:h-[calc(100vh-64px-env(safe-area-inset-top))] md:supports-[height:100dvh]:h-[calc(100dvh-64px-env(safe-area-inset-top))]';

/** Donde sale el primer aviso flotante (seccion "Componentes nuevos", Aviso flotante): 16 px debajo de la barra
 *  donde la hay; donde no (entrar, registrarse), 16 px desde arriba. Siempre mas la zona segura. Son valores de CSS
 *  para la prop `offset` de sonner, no clases. */
export function arribaDeLosAvisos(hayBarra, ancho) {
  if (!hayBarra) return 'calc(16px + env(safe-area-inset-top, 0px))';
  return ancho
    ? 'calc(64px + env(safe-area-inset-top, 0px) + 16px)'
    : 'calc(56px + env(safe-area-inset-top, 0px) + 16px)';
}

/* ¿Hay barra de arriba en la pantalla? La pinta el chasis (`AppLayout`), y los avisos flotantes viven fuera de el
   (el `Toaster` de App.js), asi que el chasis la anuncia aqui al montarse y la retira al desmontarse. Un contador y
   no un booleano: en un cambio de ruta el chasis nuevo puede montarse antes de que el viejo se desmonte. */
let barrasMontadas = 0;
const oyentesDeLaBarra = new Set();

function avisarDeLaBarra() {
  oyentesDeLaBarra.forEach((fn) => fn());
}

export function anunciarBarra() {
  barrasMontadas += 1;
  avisarDeLaBarra();
  let retirada = false;
  return () => {
    if (retirada) return;
    retirada = true;
    barrasMontadas = Math.max(0, barrasMontadas - 1);
    avisarDeLaBarra();
  };
}

function suscribirBarra(fn) {
  oyentesDeLaBarra.add(fn);
  return () => oyentesDeLaBarra.delete(fn);
}

function hayBarraAhora() {
  return barrasMontadas > 0;
}

export function useHayBarra() {
  return useSyncExternalStore(suscribirBarra, hayBarraAhora, hayBarraAhora);
}
